<script setup>
defineOptions({ inheritAttrs: false });
defineProps({
	modal: {
		type: Boolean,
		default: false
	},
	persist: {
		type: Boolean,
		default: false
	}
});
defineEmits(["close"]);
</script>

<template>
	<Teleport to="body">
		<div class="ui-dialog ui-backdrop" @mousedown.left.self="!modal && !persist && $emit('close')">
			<div class="content" v-bind="$attrs">
				<button v-if="!modal" class="close ui icon" @click="$emit('close')"><i class="ui-xmark"/></button>
				<slot/>
			</div>
		</div>
	</Teleport>
</template>
